export default __webpack_public_path__ + "static/084-c6cde85c4e7879e0a0b7f1c46a5048b4.jpg";